"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.UnstyledList = exports.Wrapper = exports.ActiveIndicator = exports.MenuItem = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _framerMotion = require("framer-motion");

var MenuItem = (0, _styled.default)(_framerMotion.motion.div)(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      mediaQueries = _ref$theme.mediaQueries,
      space = _ref$theme.space;
  return _defineProperty({
    padding: "".concat(space.xlarge, " ").concat(space.medium),
    position: 'relative',
    cursor: 'pointer',
    fontSize: '1.4rem',
    textDecoration: 'none',
    color: colors.primary
  }, mediaQueries.xlarge, {
    padding: "".concat(space.xlarge, " ").concat(space.large),
    fontSize: '1.6rem'
  });
});
exports.MenuItem = MenuItem;
var ActiveIndicator = (0, _styled.default)(_framerMotion.motion.div)(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      nav = _ref3$theme.nav,
      space = _ref3$theme.space;
  return {
    backgroundColor: colors[nav.accentColor],
    left: '50%',
    transform: 'translateX(-50%)',
    height: '0.2rem',
    position: 'relative',
    bottom: "-".concat(space.xsmall),
    pointerEvents: 'none'
  };
});
exports.ActiveIndicator = ActiveIndicator;
var Wrapper = (0, _styled.default)('nav')(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      mediaQueries = _ref4$theme.mediaQueries,
      space = _ref4$theme.space;
  return _defineProperty({
    display: 'flex',
    alignItems: 'center',
    padding: "0 ".concat(space.base)
  }, mediaQueries.xlarge, {
    padding: "0 ".concat(space.base)
  });
});
exports.Wrapper = Wrapper;
var UnstyledList = (0, _styled.default)('ul')({
  listStyleType: 'none',
  margin: 0,
  padding: 0,
  display: 'inherit'
});
exports.UnstyledList = UnstyledList;
var _default = Wrapper;
exports.default = _default;